export default __webpack_public_path__ + "static/media/Zoo_FlamingoAd.7ef523a1.jpg";